import React from 'react';

import { ImageIcon, Package } from 'lucide-react';

import PosV2StockBadge from './PosV2StockBadge';

import { fmt, resolvePosCatalogPrice } from './posV2Utils';

import { stockPhotoUrl } from './posV2PhotoUtils';



const BADGE_COLORS = {

  ventes: 'bg-blue-900/40 text-blue-200 border-blue-500/40',

  reparations: 'bg-amber-900/40 text-amber-200 border-amber-500/40',

  commandes: 'bg-purple-900/40 text-purple-200 border-purple-500/40',

  skip: 'bg-gray-800 text-gray-400 border-gray-600',

};



const LineBadge = ({ ctype }) => {

  const label = ctype === 'reparations' ? 'REP' : ctype === 'commandes' ? 'CMD' : ctype === 'ventes' ? 'VENTE' : ctype?.toUpperCase?.() || '—';

  return (

    <span className={`text-[10px] px-1.5 py-0.5 rounded border font-bold uppercase shrink-0 ${BADGE_COLORS[ctype] || BADGE_COLORS.skip}`}>

      {label}

    </span>

  );

};



const PosV2CatalogGrid = ({ items, sessionMag, onAdd, onDetail, photoBust }) => (

  <div className="flex flex-col gap-3 max-h-[calc(100vh-300px)] overflow-y-auto pr-1 pb-1">

    {items.map((item) => {

      const thumb = stockPhotoUrl(item.thumbnail_url, photoBust || undefined);
      const { eff, base, hasPromo } = resolvePosCatalogPrice(item);

      return (

        <article

          key={`${item.reference}-${item.stock_magasin_id}`}

          className="rounded-xl border border-white/10 bg-[#151820] flex gap-3 p-3 shrink-0 overflow-hidden w-full min-w-0"

        >

          <button

            type="button"

            onClick={() => onDetail?.(item)}

            aria-label={`Fiche ${item.designation || item.reference}`}

            className="shrink-0 w-[72px] h-[72px] rounded-lg bg-black/40 border border-white/10 flex items-center justify-center overflow-hidden hover:border-red-500/40 transition"

          >

            {thumb ? (

              <img src={thumb} alt="" className="w-full h-full object-contain p-1" />

            ) : (

              <Package size={22} strokeWidth={1.25} className="text-gray-600 opacity-50" />

            )}

          </button>



          <div className="flex-1 min-w-0 flex flex-col gap-1.5 py-0.5">

            <button type="button" onClick={() => onDetail?.(item)} className="text-left min-w-0 w-full">

              <p className="text-[10px] text-gray-400 font-mono truncate leading-tight" title={item.reference}>

                {item.reference}

              </p>

              <p className="text-sm font-semibold text-white leading-snug line-clamp-2 mt-0.5" title={item.designation}>

                {item.designation}

              </p>

            </button>



            <div className="flex items-end justify-between gap-2 pt-2 mt-auto border-t border-white/5 min-w-0">

              <div className="flex flex-col gap-0.5 min-w-0 flex-1">

                <PosV2StockBadge

                  sessionMag={sessionMag}

                  stockMag={item.stock_magasin_id}

                  stockLocal={item.stock_local}

                />
                {item.out_of_stock && (
                  <span className="text-[10px] px-1.5 py-0.5 rounded border border-orange-500/50 text-orange-300 bg-orange-950/30 font-bold uppercase">
                    Rupture
                  </span>
                )}

                <span className="text-[10px] text-gray-500 truncate">

                  M1:{item.availability?.M1 ?? 0} · M2:{item.availability?.M2 ?? 0}

                </span>

              </div>

              <div className="flex flex-col items-end shrink-0 gap-0.5">
                {hasPromo && (
                  <span className="text-[10px] text-gray-500 line-through tabular-nums">{fmt(base)} €</span>
                )}
                <span className={`text-base font-bold shrink-0 whitespace-nowrap tabular-nums leading-none pb-0.5 ${hasPromo ? 'text-emerald-400' : 'text-red-400'}`}>
                  {fmt(eff)} €
                </span>
                {hasPromo && (
                  <span className="text-[9px] font-bold uppercase text-emerald-300/90">Promo</span>
                )}
              </div>

            </div>

          </div>



          <div className="shrink-0 flex flex-col gap-1.5 justify-center">

            <button

              type="button"

              onClick={() => onDetail?.(item)}

              className="min-w-[56px] min-h-[38px] px-2 rounded-lg bg-white/10 hover:bg-white/15 text-[10px] font-semibold text-gray-200 flex items-center justify-center gap-1"

              title="Galerie photos · stock"

            >

              <ImageIcon size={14} />

              Fiche

            </button>

            <button

              type="button"

              onClick={() => onAdd(item)}

              className={`min-w-[56px] min-h-[38px] px-2 rounded-lg text-[10px] font-bold text-white ${
                item.out_of_stock ? 'bg-orange-600 hover:bg-orange-500' : 'bg-red-600 hover:bg-red-500'
              }`}

              title={item.out_of_stock ? 'Vente sans décrément stock (rupture)' : 'Ajouter au panier'}

            >

              {item.out_of_stock ? 'Rupture' : '+ Panier'}

            </button>

          </div>

        </article>

      );

    })}

    {!items.length && (

      <p className="text-gray-500 text-sm py-8 text-center">Aucun article — recherchez ou changez de page</p>

    )}

  </div>

);



export { LineBadge, PosV2CatalogGrid };


